module.exports = __webpack_public_path__ + "static/img/ci.c45a8c0.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/lotte-tms/ci.png
// module id = ry5D
// module chunks = 0